export default "__VITE_ASSET__1e572f73__"